import type { StatusCountPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * One row of `VerificationProgressView.byStatus`: a verification state and its count.
 */
class StatusCountView {
	readonly status: LabeledValueView;
	readonly count: number;

	constructor(payload: StatusCountPayload) {
		this.status = new LabeledValueView(payload.status);
		this.count = payload.count;

		Object.freeze(this);
	}
}

export default StatusCountView;
